import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { UpgradeIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import withErrorBoundary from '../ErrorBoundary';
import { MC0653_USAGE_LIMIT_BANNER } from '../_core/common/constants/ErrorBoundaryNames';
import { USAGE_LIMIT_BANNER } from '../_core/common/constants/PurchaseMotionLocations';
import { track } from '../_core/common/eventTracking/tracker';
import { PRICING_PAGE_REDIRECT } from '../_core/purchaseMotions/PurchaseMotionTypes';
import { getUpgradeDataFromUpgradeConfig } from '../_core/utils/getUpgradeDataFromUpgradeConfig';
import UIPurchaseMotionButton from '../button/UIPurchaseMotionButton';
import { getUpgradeDataTrackingProperties } from '../ums/utils';
import { MC0653_BANNER_UPGRADE_CONFIG } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "MC0653UsageLimitBanner__Container",
  componentId: "sc-1h8vst0-0"
})(({
  theme
}) => ({
  display: 'flex',
  zIndex: 100,
  backgroundColor: theme.color['fill-primary-subtle'],
  paddingBlock: theme.space['200'],
  paddingInline: theme.space['400'],
  justifyContent: 'center',
  position: 'sticky',
  insetBlockStart: theme.space['0'],
  alignItems: 'center'
}));
const MC0653UsageLimitBanner = ({
  value,
  limit,
  displayThreshold
}) => {
  const upgradeData = getUpgradeDataFromUpgradeConfig(MC0653_BANNER_UPGRADE_CONFIG);
  const isValueBelowDisplayThreshold = useMemo(() => {
    return displayThreshold && value !== undefined && value >= 0 && value < displayThreshold;
  }, [displayThreshold, value]);
  const percentageUsed = Math.round(value / limit * 100);
  const atLimit = value >= limit;
  const hasReachedLimit = value >= limit;
  useEffect(() => {
    if (!isValueBelowDisplayThreshold) {
      const limitInteractionTrackingData = {
        limit,
        value,
        displayThreshold,
        hasReachedLimit
      };
      track('interaction', Object.assign({
        action: 'viewed upgrade point'
      }, limitInteractionTrackingData, getUpgradeDataTrackingProperties(upgradeData)));
    }
  }, [isValueBelowDisplayThreshold, displayThreshold, limit, value, hasReachedLimit, upgradeData]);
  if (isValueBelowDisplayThreshold) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Flex, {
      minInlineSize: "600",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(UpgradeIcon, {
        size: "600",
        color: "fill-primary-default"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      marginInlineStart: "300",
      alignItems: "center",
      flexWrap: "wrap",
      children: [/*#__PURE__*/_jsxs(Text, {
        as: "span",
        typography: "heading-50",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: atLimit ? 'upgrades.usageLimitBanner.header.mc0653.atLimit' : 'upgrades.usageLimitBanner.header.mc0653.belowLimit',
          options: {
            percentageUsed
          }
        }), "\xA0"]
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: atLimit ? 'upgrades.usageLimitBanner.subtext.mc0653.atLimit' : 'upgrades.usageLimitBanner.subtext.mc0653.belowLimit'
      }), "\xA0", /*#__PURE__*/_jsx(Flex, {
        children: /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
          upgradeData: upgradeData,
          use: "link",
          block: false,
          level: 1,
          purchaseMotions: [PRICING_PAGE_REDIRECT],
          goToUpgradePage: true,
          location: USAGE_LIMIT_BANNER,
          usageLimitBannerData: {
            limit,
            value,
            displayThreshold,
            hasReachedLimit
          },
          children: /*#__PURE__*/_jsx(Link, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "upgrades.upgradeButton.mc0653Cta"
            })
          })
        })
      })]
    })]
  });
};
export default withErrorBoundary(MC0653UsageLimitBanner, {
  boundaryName: MC0653_USAGE_LIMIT_BANNER
});